
// - Basic settings - //

  // server
  export const API_URL = 'https://api.brno.qtcloud.cz';
  // 'https://api.qtcloud.cz'; - Tetronik testovaci server
  // 'https://api.qa.qtcloud.cz'; - TETRAC  TESTOVACI
  // 'http://31.31.72.155:8888'; - SoFair testovaci

  export const APP_TITLE = 'Rezervační systém';
  // Google maps api key
  export const GOOGLE_API_KEY = 'AIzaSyDYNQYgSxetOOxyKCsBEotiYEIyAX7HK0M';

  // google recapcha v2
  export const CAPRCHA_CLIENT_KEY = '6LchWxYUAAAAAHS5JBSMFlSP3Fu-uHNr47WYzU0W';

  // single office mode
  export const SINGLE_OFFICE_MODE = true;

  // graph statistics
  // - default: month or year 
  export const STATS_DEFAULT_SETTING = 'year';
  // - if switching is bad idea
  export const STATS_SHOW_DATE_SWITCH = true;

// -------------------- //


// ~ Colors ~ //

  // color 1 
  //  - main color in header and selected button
  export const COLOR_1 = '#CB0E21';
  export const COLOR_1_BORDER_BOTTOM = '#CB0E21';
  export const COLOR_1_BORDER_LEFT = '#CB0E21';

  // color 2
  //  - color in header under logo
  export const COLOR_2 = '#8a0b17';
  export const COLOR_2_BORDER_BOTTOM = '#8a0b17';
  export const COLOR_2_BORDER_RIGHT = '#8a0b17';

  // color 3
  //  - side panel color
  export const COLOR_3 = '#2e3647';
  export const COLOR_3_BORDER_RIGHT = 'rgba(73, 79, 94, 0.71)';

// -------------------- //
